<template>
  <div>
    <el-dialog
      title="余额明细"
      width="600px"
      :append-to-body="true"
      :modal-append-to-body="false"
      v-on="$listeners"
      v-bind="$attrs"
      @close="handleClose"
      @open="handleOpen"
    >
      <div class="over">
        <el-table :data="turnoverList" height="400">
          <el-table-column label="操作" prop="remark" width="230px" />
          <el-table-column label="日期" prop="addtime" min-width="50px" />
          <el-table-column label="金额(元)" prop="{ row }" min-width="50px">
            <template slot-scope="{ row }">
              <span class="green" :class="row.num < 0 ? 'red' : ''">{{
                row.num | turnNum
              }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagenation">
          <el-pagination
            @size-change="onTurnoverSizeChange"
            @current-change="onTurnoverCurrentChange"
            :current-page="turnoverPagination.page"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="turnoverPagination.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="turnoverPagination.recordcount"
          ></el-pagination>
        </div>
      </div>
    </el-dialog> 
  </div>
</template>

<script>
import { taoke_cms_member_money_log } from '@/api/finance';
export default {
  props: {
    turnoverId: [Number, String],
  },
  filters: {
    turnNum(val) {
      if (val <= 0) {
        return val;
      } else {
        return '+' + val;
      }
    },
  },
  data() {
    return {
      turnoverList: [],
      turnoverPagination: {
        page: 1, // 当前页
        pagesize: 10, // 每页大小
        pagecount: 1, // 总页数
        recordcount: 40, // 总条数
      },
    }
  },
  methods: {
    // 关闭
    handleClose() {
      this.$emit('update:visible', false)
    },
    // 打开
    handleOpen() {
      this.getTurnoverList(this.turnoverId);
    },
    //流水分页器
    onTurnoverSizeChange(pagesize) {
      this.turnoverPagination.pagesize = pagesize;
      this.getTurnoverList(this.turnoverId);
    },
    //获取流水数据
    getTurnoverList(id) {
      taoke_cms_member_money_log({
        ...this.turnoverPagination,
        cms_member_id: id,
      }).then(({ data }) => {
        if (data.error_code == 0) {
          this.turnoverList = [];
          this.turnoverList = data.list;
          this.turnoverPagination.pagecount = data.pagecount;
          this.turnoverPagination.recordcount = data.recordcount;
        }
      });
    },
    // 切换页面
    onTurnoverCurrentChange(page) {
      this.turnoverPagination.page = page;
      this.getTurnoverList(this.turnoverId);
    },
  },
}
</script>

<style lang="scss" scoped>
.green {
  color: #3ac282;
}
.red {
  color: #fe4242;
}
.pagenation {
  margin-top: 20px;
  text-align: right;
}

.pagination {
  text-align: right;
}
</style>